var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticStyle:{"position":"relative"},attrs:{"loading":_vm.loading}},[(_vm.error)?_c('page-error',{attrs:{"message":_vm.error}}):(_vm.authorised)?_c('iframe',{ref:"application",attrs:{"src":_vm.src,"width":"100%","height":"100%","frameborder":"0","allowtransparency":""},on:{"load":_vm.iframeLoaded}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ab7fd4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ml-studio/pages/MlStudioApplicationPage.vue
// module id = null
// module chunks = 